let __flarum_default_export__;
export default __flarum_default_export__ = {
  "schemaVersion": 1,
  "kind": "forum-brand-taglines",
  "status": "package-snapshot",
  "verifiedAt": "2026-09-17",
  "selectionPolicy": "Every canonical brand board must have a non-empty display tagline. Prefer a current official OEM brand line when it is distinctive and well established; otherwise prefer the most recognizable official historic slogan, brand promise, mission, or campaign. Umbrella/catchall boards may use a clearly identified FlatRate.wiki-selected line.",
  "taglines": [{
    "key": "acura",
    "name": "Acura",
    "tagline": "Precision Crafted Performance",
    "provenance": "current-official",
    "sourceUrl": "https://www.acura.com/"
  }, {
    "key": "alfa-romeo",
    "name": "Alfa Romeo",
    "tagline": "The Mechanics of Emotion",
    "provenance": "official-iconic-english-rendering",
    "sourceUrl": "https://www.media.stellantis.com/it-it/alfa-romeo/press/anteprima-mondiale-della-alfa-romeo-giulia"
  }, {
    "key": "aston-martin",
    "name": "Aston Martin",
    "tagline": "Power, Beauty and Soul",
    "provenance": "official-iconic-brand-line",
    "sourceUrl": "https://www.astonmartin.com/en/our-world/news/2017/2/20/company"
  }, {
    "key": "audi",
    "name": "Audi",
    "tagline": "Vorsprung durch Technik",
    "provenance": "current-official",
    "sourceUrl": "https://www.audi.com/en/company-history-17227"
  }, {
    "key": "bentley",
    "name": "Bentley",
    "tagline": "Relentlessly Extraordinary",
    "provenance": "current-official-manifesto",
    "sourceUrl": "https://www.bentleymotors.com/en/about-bentley/beyond-100/bentley-brand-manifesto.html"
  }, {
    "key": "bmw",
    "name": "BMW",
    "tagline": "The Ultimate Driving Machine",
    "provenance": "official-iconic",
    "sourceUrl": "https://www.press.bmwgroup.com/usa/article/detail/T0447993EN_US/chapter-6%3A-%E2%80%9Cthe-ultimate-ad-slogan%3A-bmw-becomes-the-ultimate-driving-machine%E2%80%9D?language=en_US"
  }, {
    "key": "cdjr",
    "name": "CDJR",
    "tagline": "Mopar",
    "provenance": "user-selected-umbrella-official-mopar",
    "sourceUrl": "https://www.mopar.com/"
  }, {
    "key": "buick",
    "name": "Buick",
    "tagline": "When Better Automobiles Are Built, Buick Will Build Them",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://texashistory.unt.edu/ark:/67531/metapth1592370/m1/56/"
  }, {
    "key": "cadillac",
    "name": "Cadillac",
    "tagline": "Standard of the World",
    "provenance": "official-iconic",
    "sourceUrl": "https://www.cadillac.com/electric/celestiq"
  }, {
    "key": "chevrolet",
    "name": "Chevrolet",
    "tagline": "The Heartbeat of America",
    "provenance": "official-iconic",
    "sourceUrl": "https://news.gm.com/home.detail.html/Pages/topic/us/en/2026/jun/0624-heartbeat-america.html"
  }, {
    "key": "chrysler",
    "name": "Chrysler",
    "tagline": "Imported from Detroit",
    "provenance": "official-iconic-campaign",
    "sourceUrl": "https://www.chrysler.com/"
  }, {
    "key": "dodge",
    "name": "Dodge",
    "tagline": "Domestic. Not Domesticated.",
    "provenance": "official-iconic-campaign",
    "sourceUrl": "https://www.dodge.com/"
  }, {
    "key": "ferrari",
    "name": "Ferrari",
    "tagline": "The Best Ferrari Ever Built Is the Next One",
    "provenance": "official-iconic-enzo-ferrari-line",
    "sourceUrl": "https://cdn.ferrari.com/cms/network/media/pdf/16_f-1_prospectus.pdf"
  }, {
    "key": "ford",
    "name": "Ford",
    "tagline": "Built Ford Tough",
    "provenance": "official-iconic",
    "sourceUrl": "https://media.ford.com/content/fordmedia/fna/ca/en/news/2017/07/27/ford-celebrates-100-years-truck-history.html"
  }, {
    "key": "genesis",
    "name": "Genesis",
    "tagline": "Every Drive Deserves to Be a Discovery",
    "provenance": "current-official-brand-belief",
    "sourceUrl": "https://www.genesis.com/worldwide/en/genesis/brand/brand-overview.html"
  }, {
    "key": "gm",
    "name": "GM",
    "tagline": "Mark of Excellence",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://www.gm.com/content/dam/company/no_search/heritage-archive-docs/vehicle-information-kits/oldsmobile/1970_Oldsmobile_442_Info_Kit.pdf"
  }, {
    "key": "gmc",
    "name": "GMC",
    "tagline": "Professional Grade",
    "provenance": "current-official-ethos",
    "sourceUrl": "https://news.gmc.com/newsroom.detail.html/Pages/news/us/en/2026/jun/0625-gmc-sierra-1500.html"
  }, {
    "key": "honda",
    "name": "Honda",
    "tagline": "The Power of Dreams",
    "provenance": "current-official",
    "sourceUrl": "https://world.honda.com/"
  }, {
    "key": "hyundai",
    "name": "Hyundai",
    "tagline": "New Thinking. New Possibilities.",
    "provenance": "official-iconic-brand-slogan",
    "sourceUrl": "https://www.hyundai.com/content/dam/hyundai/ww/en/images/about-hyundai/ir/financial-statements/annual-report/hw039016.pdf"
  }, {
    "key": "infiniti",
    "name": "Infiniti",
    "tagline": "Inspired Performance",
    "provenance": "official-iconic-brand-promise",
    "sourceUrl": "https://usa.infinitinews.com/en-US/releases/release-a956b62824a946ce9b7c67fa7d9e4947-infiniti-history"
  }, {
    "key": "jlr",
    "name": "JLR",
    "tagline": "Reimagine",
    "provenance": "current-official-strategy",
    "sourceUrl": "https://www.jlr.com/reimagine"
  }, {
    "key": "jaguar",
    "name": "Jaguar",
    "tagline": "Grace, Space, Pace",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://jamaica.jaguar.com/about-jaguar/80-years-of-jaguar/80-years-of-jaguar-part-3"
  }, {
    "key": "land-rover",
    "name": "Land Rover",
    "tagline": "Above and Beyond",
    "provenance": "official-iconic",
    "sourceUrl": "https://www.landrover.com/explore-land-rover/index.html"
  }, {
    "key": "jeep",
    "name": "Jeep",
    "tagline": "Go Anywhere. Do Anything.",
    "provenance": "official-iconic-brand-spirit",
    "sourceUrl": "https://blog.stellantisnorthamerica.com/2022/03/23/jeep-brand-acknowledges-the-sunset-chasers-adrenaline-junkies-nature-lovers-athletes-and-more-in-new-marketing-campaign-for-grand-cherokee/"
  }, {
    "key": "kia",
    "name": "Kia",
    "tagline": "The Power to Surprise",
    "provenance": "official-iconic-former-brand-slogan",
    "sourceUrl": "https://www.kia.com/nmc/en/discover-kia/ask/what-is-kias-slogan.html"
  }, {
    "key": "lamborghini",
    "name": "Lamborghini",
    "tagline": "Driving Humans Beyond",
    "provenance": "current-official-manifesto",
    "sourceUrl": "https://www.lamborghini.com/en-en/beyond/brand-manifesto"
  }, {
    "key": "lexus",
    "name": "Lexus",
    "tagline": "The Relentless Pursuit of Perfection",
    "provenance": "official-iconic",
    "sourceUrl": "https://pressroom.lexus.com/history/"
  }, {
    "key": "lincoln",
    "name": "Lincoln",
    "tagline": "What a Luxury Car Should Be",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://www.thehenryford.org/collections/explore/artifact/367714"
  }, {
    "key": "maserati",
    "name": "Maserati",
    "tagline": "The Absolute Opposite of Ordinary",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://www.media.stellantis.com/us-en/maserati/press/maserati-starts-celebration-of-first-100-years"
  }, {
    "key": "mazda",
    "name": "Mazda",
    "tagline": "Zoom-Zoom",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://newsroom.mazda.com/en/publicity/release/2002/200204/0408e.html"
  }, {
    "key": "mclaren",
    "name": "McLaren",
    "tagline": "Fearlessly Forward",
    "provenance": "user-selected-official-mclaren-racing",
    "sourceUrl": "https://www.mclaren.com/racing/team/fearlessly-forward/"
  }, {
    "key": "mercedes-benz",
    "name": "Mercedes-Benz",
    "tagline": "The Best or Nothing",
    "provenance": "current-official-motto",
    "sourceUrl": "https://group.mercedes-benz.com/documents/investors/reports/annual-report/daimler/daimler-ir-annualreport-2009.pdf"
  }, {
    "key": "mini",
    "name": "MINI",
    "tagline": "Let's Motor",
    "provenance": "official-iconic-historic",
    "sourceUrl": "https://www.mini.com/"
  }, {
    "key": "mitsubishi",
    "name": "Mitsubishi",
    "tagline": "Drive Your Ambition",
    "provenance": "current-official-global-tagline",
    "sourceUrl": "https://www.mitsubishi-motors.com/en/investors/corpmanage/"
  }, {
    "key": "nissan",
    "name": "Nissan",
    "tagline": "Innovation that Excites",
    "provenance": "official-iconic-global-campaign",
    "sourceUrl": "https://www.nissan-global.com/EN/DOCUMENT/PDF/FINANCIAL/PRESEN/2011/2011results_presentation_451_e.pdf"
  }, {
    "key": "other-makes",
    "name": "Other Makes",
    "tagline": "Every Make. Every Job.",
    "provenance": "flatrate-selected",
    "sourceUrl": null
  }, {
    "key": "porsche",
    "name": "Porsche",
    "tagline": "There Is No Substitute",
    "provenance": "current-official-shared-belief",
    "sourceUrl": "https://www.porsche.com/usa/stories/experience/porsche-there-is-no-substitute/"
  }, {
    "key": "ram",
    "name": "Ram",
    "tagline": "Built to Serve",
    "provenance": "current-official-brand-promise",
    "sourceUrl": "https://www.ramtrucks.com/electric.html"
  }, {
    "key": "range-rover",
    "name": "Range Rover",
    "tagline": "The Original Luxury SUV",
    "provenance": "current-official-descriptor",
    "sourceUrl": "https://www.rangerover.com/en-us/range-rover/index.html"
  }, {
    "key": "rivian",
    "name": "Rivian",
    "tagline": "Keep the World Adventurous Forever",
    "provenance": "current-official-mission",
    "sourceUrl": "https://careers.rivian.com/careers-home/"
  }, {
    "key": "subaru",
    "name": "Subaru",
    "tagline": "Love. It's What Makes a Subaru, a Subaru.",
    "provenance": "current-official",
    "sourceUrl": "https://www.subaru.com/vehicles/reasons-to-love"
  }, {
    "key": "tesla",
    "name": "Tesla",
    "tagline": "Accelerating the World's Transition to Sustainable Energy",
    "provenance": "official-iconic-mission",
    "sourceUrl": "https://www.tesla.com/about"
  }, {
    "key": "toyota",
    "name": "Toyota",
    "tagline": "Let's Go Places",
    "provenance": "current-official-us-tagline",
    "sourceUrl": "https://brand.toyota.com/guidelines/visual/logos"
  }, {
    "key": "volkswagen",
    "name": "Volkswagen",
    "tagline": "Drivers Wanted",
    "provenance": "official-iconic-currently-revived",
    "sourceUrl": "https://www.youtube.com/watch?v=U9ZlAGAqv0w"
  }, {
    "key": "volvo",
    "name": "Volvo",
    "tagline": "For Life",
    "provenance": "official-iconic-brand-line",
    "sourceUrl": "https://www.volvocars.com/us/our-story/"
  }],
  "controlAuthority": "flatrate-wiki configs/forum/brand-taglines.json (FORUM-BRAND-JLR-001 / #548; not yet on main)",
  "sourcedFrom": "closed PR #340 researched catalog; ported without taxonomy mutation",
  "jlrHierarchyControl": "BLOCKED_UNTIL_548",
  "filteredToManifestPlusPendingJlr": true,
  "droppedFromPr340Catalog": []
};
flarum.reg.add('flatrate-forum-navigation', 'forum/utils/brandTaglinesData', __flarum_default_export__);